import React from 'react';
import UUID from '../utility/UUID';
import ErrorContainer from '../components/ErrorContainer';
import ErrorMessage from '../components/ErrorMessage';
import { FieldValidationErrorsType } from '../form/FrekulForm';

export type CustomRadioOptionType = {
  value: string,
  title?: React.ReactNode,
  description?: React.ReactNode,
  view?: React.ReactNode,
};

export type CustomRadioOptionsType = CustomRadioOptionType[];

function CustomRadioItem({
  name,
  value,
  checked,
  setChecked,
  children,
}: {
  name: string,
  value: string,
  checked: boolean,
  setChecked: () => void,
  children: React.ReactNode,
}) {
  const [uuid] = React.useState(UUID.generateUUID());
  return (
    <div className="radio__item">
      <input
        type="radio"
        className="radio"
        name={name}
        id={uuid}
        value={value}
        checked={checked}
        onChange={(e) => { if (e.target.checked) { setChecked(); } }}
      />
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label htmlFor={uuid}>
        {children}
      </label>
    </div>
  );
}

function CustomRadioView({
  options,
  value,
  setValue,
}: {
  value: string,
  setValue: (value: string) => void,
  options: CustomRadioOptionsType,
}) {
  const [uuid] = React.useState(UUID.generateUUID());
  return (
    <div className="radio__list">
      {options.map((option) => (
        <CustomRadioItem
          key={option.value}
          name={uuid}
          value={option.value}
          checked={value === option.value}
          setChecked={() => setValue(option.value)}
        >
          {option.view || (
            <div className="radio__wrap">
              <h3 className="radio__header">
                <span className="radio__title">
                  {option.title}
                </span>
              </h3>
              {option.description && (
                <p className="radio__text">
                  {option.description}
                </p>
              )}
            </div>
          )}
        </CustomRadioItem>
      ))}
    </div>
  );
}

export default function CustomRadio({
  options,
  value,
  setValue,
  validationErrors = {},
} : {
  value: string,
  setValue: (value: string) => void,
  options: CustomRadioOptionsType,
  validationErrors?: FieldValidationErrorsType
}) {
  return (
    <>
      <ErrorContainer
        isError={Object.keys(validationErrors).length > 0}
      >
        <CustomRadioView
          options={options}
          value={value}
          setValue={setValue}
        />
      </ErrorContainer>
      <ErrorMessage type="error" validationErrors={validationErrors} />
    </>
  );
}
